<template>
    <transition
        enter-active-class="transform ease-out duration-300 transition"
        enter-from-class="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
        enter-to-class="translate-y-0 opacity-100 sm:translate-x-0"
        leave-active-class="transition ease-in duration-100"
        leave-from-class="opacity-100"
        leave-to-class="opacity-0"
    >
        <div
            v-if="isVisible"
            class="pointer-events-auto w-full max-w-md overflow-hidden rounded-lg bg-white ring-1 shadow-lg ring-black/5 fixed bottom-4 right-4 z-50"
        >
            <div class="p-4">
                <div class="flex items-start">
                    <div class="shrink-0">
                        <svg class="h-6 w-6 text-blue-400" fill="currentColor" viewBox="0 0 20 20">
                            <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clip-rule="evenodd" />
                        </svg>
                    </div>
                    <div class="ml-3 w-0 flex-1 pt-0.5">
                        <p class="text-sm font-medium text-gray-900">{{ $t('notifications.new_feature.toast_title') }}</p>
                        <div class="mt-2 text-sm text-gray-600 leading-relaxed">
                            <p class="mb-2">{{ $t('notifications.new_feature.description') }}</p>
                            <ul class="list-disc list-inside space-y-1 text-xs text-gray-500">
                                <li>{{ $t('notifications.new_feature.feature_1') }}</li>
                                <li>{{ $t('notifications.new_feature.feature_2') }}</li>
                                <li class="flex items-center gap-1">
                                    {{ isMac ? $t('notifications.new_feature.feature_3_mac') : $t('notifications.new_feature.feature_3_other') }}
                                    <span class="inline-flex items-center gap-1">
                                        <kbd class="px-1.5 py-0.5 text-xs font-semibold text-gray-800 bg-gray-100 border border-gray-200 rounded-md">
                                            {{ isMac ? '⌘' : 'Ctrl' }}
                                        </kbd>
                                        <span class="text-gray-400">+</span>
                                        <kbd class="px-1.5 py-0.5 text-xs font-semibold text-gray-800 bg-gray-100 border border-gray-200 rounded-md">
                                            A
                                        </kbd>
                                    </span>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="ml-4 flex shrink-0">
                        <button
                            type="button"
                            @click="dismiss"
                            class="inline-flex rounded-md bg-white text-gray-400 hover:text-gray-500 focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 focus:outline-hidden"
                        >
                            <span class="sr-only">{{ $t('common.close') }}</span>
                            <svg class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'NewFeatureToastComponent',

    props: {
        isVisible: {
            type: Boolean,
            default: false
        }
    },

    emits: ['dismiss'],

    computed: {
        isMac(): boolean {
            return navigator.platform.toUpperCase().indexOf('MAC') >= 0;
        }
    },

    methods: {
        dismiss() {
            this.$emit('dismiss');
        }
    }
});
</script>
